import request from "../request";

import { REACT_BASE_URL_GAMA_USERS, REACT_BASE_URL_GAMA_AUTH } from "../url";

export const getGamaRequest = async (
  filters,
  query,
  type = "GAMA",
  search = "",
  orderBy = "DESC",
  orderByProperty = "createdAt",
) => {
  const queryParams = new URLSearchParams(query).toString();
  return await request({
    url:
      `${REACT_BASE_URL_GAMA_USERS}/users?type=${type}&page=${
        filters?.currentPage || 1
      }&pageSize=${9999}&orderBy=${orderBy}&orderByProperty=${orderByProperty}&` +
      queryParams,
    method: "GET",
  });
};

export const getUsersGamaRequest = async (query, filters, type = "GAMA") => {
  let {
    orderByProperty = "createdAt",
    orderBy = "DESC",
    currentPage = 1,
    pageSize = 7,
  } = query;

  var search = "";
  var role = "";
  let customer = "";
  if (filters && filters.search) {
    search = typeof filters.search !== "undefined" ? filters.search : "";
  }

  if (filters && filters.role) {
    role = typeof filters.role !== "undefined" ? filters.role : "";
  }

  if (filters && filters.customer) {
    customer = typeof filters.customer !== "undefined" ? filters.customer : "";
  }

  if (!orderBy) {
    orderBy = "DESC";
  }

  const params = {
    type,
    orderBy,
    orderByProperty,
    page: currentPage,
    pageSize,
    search,
    role,
    customer,
  };

  const queryParams = new URLSearchParams(params);
  return await request({
    url: REACT_BASE_URL_GAMA_USERS + "/users?" + queryParams,
    method: "GET",
  });
};

export const getUserRequest = async (userId) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/${userId}`,
    method: "GET",
  });
};

export const getMineUserRequest = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/mine`,
    method: "GET",
  });
};

export const updateDriverIdentityCard = async (data, documentType) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile/identity-document`,
    method: "PUT",
    data: {
      files: data,
      documentType,
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getDriverIdentityCard = async (type) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile/identity-document?documentType=${type}`,
    method: "GET",
  });
};

export const updateDriverLicense = async (data) => {
  console.log(data, "data");
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile/driver-license`,
    method: "PUT",
    data: {
      files: data,
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getDriverLicense = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile/driver-license`,
    method: "GET",
  });
};

export const updateDriverProfile = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile`,
    method: "PATCH",
    data: data,
  });
};

export const deteleDriverLicense = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/profile`,
    method: "PATCH",
    data: data,
  });
};

export const getAssignedPlates = async (customerRut) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/gama-365/customers/plates?customerRut=${customerRut}`,
    method: "GET",
  });
};

export const getPlates = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/plates`,
    method: "GET",
  });
};

export const getDocName = async (docType, deviceId) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/sharepoint/documents?docType=${docType}&keyword=${deviceId}`,
    method: "GET",
  });
};

export const getBlobForDocument = async (selectedPlate, docType) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/sharepoint/documents/${selectedPlate}?docType=${docType}`,
    method: "GET",
  });
};

export const getProfilePic = async (data) => {
  console.log(data, "data");
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/profile/image`,
    method: "GET",
  });
};

export const findUserByRut = async (userRut) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/find/rut/${userRut}`,
    method: "GET",
  });
};
export const getUserCount = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/count`,
    method: "GET",
  });
};

export const findUserByEmail = async (userEmail) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/find/email/${userEmail}`,
    method: "GET",
  });
};

export const findAccessUser = async (token) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/find-access/mine`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addUserToCompanyRequest = async (user) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users`,
    method: "POST",
    data: {
      ...user,
    },
  });
};

export const getAllUserCust = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/customers/assignment/list`,
    method: "GET",
  });
};

export const updateUserRequest = async ({ userId, data }) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/${userId}`,
    method: "PATCH",
    data: {
      ...data,
    },
  });
};

export const removeAccess = async (accessId) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/accesses/${accessId}`,
    method: "DELETE",
  });
};

export const passwordRecovery = async (data) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_AUTH}/auth/recovery`,
    method: "POST",
    data,
  });
};

export const passwordChange = async ({ userId, data }) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/reset/${userId}`,
    method: "PATCH",
    data: data,
  });
};

export const updateDefaultCompany = async (customerId) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/accesses/${customerId}`,
    method: "PUT",
  });
};

export const bulkUsersDataDownloadRequest = async (action) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/upload/${action}`,
    method: "GET",
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
    },
    responseType: "blob",
  });
};
export const bulkDriversDataDownloadRequest = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/drivers/upload/insert`,
    method: "GET",
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
    },
    responseType: "blob",
  });
};

export const bulkUsersDataUploadRequest = async (data, action) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/upload/${action}`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: {
      ...data,
    },
  });
};

export const bulkDriversDataUploadRequest = async (data, action) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/drivers/upload/insert`,
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: {
      ...data,
    },
  });
};

export const deleteUser = async (id) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/users/${id}`,
    method: "DELETE",
  });
};

export const exportTemplate = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_USERS}/requests/export`,
    method: "GET",
    responseType: "arraybuffer",
  });
};
